import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logger from '../services/logger';
import configService from '../services/configService';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuthState, user } = useAuth();

  const trackReferralSignup = async (cognitoUserId) => {
    const refCode = localStorage.getItem('referralCode');
    if (refCode && cognitoUserId) {
      try {
        console.log('🎁 Tracking OAuth referral signup:', { refCode, cognitoUserId });
        await configService.trackReferralSignup(refCode, cognitoUserId);
        console.log('✅ OAuth referral signup tracked successfully');
        localStorage.removeItem('referralCode');
      } catch (error) {
        console.error('❌ Failed to track OAuth referral signup:', error);
        // Don't throw error - referral tracking failure shouldn't block OAuth flow
      }
    }
  };

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Wait a moment for OAuth to complete
        await new Promise(resolve => setTimeout(resolve, 1000));
        await checkAuthState();
        
        // Log OAuth callback event
        const urlParams = new URLSearchParams(window.location.search);
        const provider = urlParams.get('provider') || 'oauth';
        
        if (user) {
          await logger.logOAuthCallback(user, provider);
          
          // Track referral signup for OAuth users
          await trackReferralSignup(user.attributes?.sub);
        }
        
        navigate('/plans');
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/signup');
      }
    };

    handleCallback();
  }, [checkAuthState, navigate, user]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <div>Processing authentication...</div>
    </div>
  );
};

export default OAuthCallback;